import { render, staticRenderFns } from "./ownerApply.vue?vue&type=template&id=8d1120ae&scoped=true&"
import script from "./ownerApply.vue?vue&type=script&lang=js&"
export * from "./ownerApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1120ae",
  null
  
)

export default component.exports